
import {
  defineComponent,
  computed,
} from 'vue';

export default defineComponent({
  props: {
    columns: {
      type: String,
      required: false,
      default: () => '1',
    },
    columnsMd: {
      type: String,
      required: false,
      default: () => '0',
    },
    columnsXs: {
      type: String,
      required: false,
      default: () => '0',
    },
    gutterSize: {
      type: String,
      required: false,
      default: () => '4',
    },
    justifyContent: {
      type: String,
      required: false,
      default: () => 'start',
    },
  },

  setup(props) {
    const gridClasses = computed<string[]>(() => {
      const gc = [`g-${props.gutterSize} cols-${props.columns}`];

      if (parseInt(props.columnsMd, 10) > 0) {
        gc.push(`cols-md-${props.columnsMd}`);
      }

      if (parseInt(props.columnsXs, 10) > 0) {
        gc.push(`cols-xs-${props.columnsXs}`);
      }

      gc.push(`justify-content-${props.justifyContent}`);

      return gc;
    });

    return {
      gridClasses,
    };
  },
});
